<template>
    <el-select
        v-model="modelValue"
        :value-key="valueKey"
        clearable
        :value="value"
        :disabled="disabled"
        :filterable="filterable"
        :remote = "remote"
        :loading="loading"
        :remote-method = "remoteMethod"
        @change="change"
        :placeholder = "placeholder"
    >
        <el-option
            v-for="item in options"
            :key="item[valueField]"
            :label="item[labelField]"
            :value="item[valueField]"
        >
        </el-option>
    </el-select> <!-- @change="test" -->
</template>

<script>
export default {
    props: {
        value: {
            type: [Number, String, Array, Object],
            default: "",
        },
        valueKey: {
            type: String,
            default: "value",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        filterable: {
            type: Boolean,
            default: false,
        },
        remote: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        remoteMethod: {
            type: Function,
            default: null,
        },
        options: {
            type: Array,
            default: () => [],
        },
        labelField: {
            type: String,
            default: "label",
        },
        valueField: {
            type: String,
            default: "value",
        },
        placeholder: {
            type: String,
            default: "请选择",
        },
        // test:{
        //     type: String,
        //     default: "value",
        // }
    },

    computed: {
        modelValue: {
            get({ value, $attrs }) {
                if ($attrs.multiple && !Array.isArray(value)) return [];
                return value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        test(event){
            console.log(event);
            console.log("value:"+this.value);
            console.log("valueKey:"+this.valueKey);
            console.log("disabled:"+this.disabled);
            console.log("options:"+this.options);
            console.log("labelField:"+this.labelField);
            console.log("valueField:"+this.valueField);
        },
        change(selectedvalue){
            this.$emit("change",selectedvalue)
        },
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner:focus {
    border-color: var(--main-color) !important;
}
</style>